import { BondResponse } from '../../type';
import { useBondsBondTransformApi } from '../api';

const bondsBondExist = (bondsBond: BondResponse | undefined) => bondsBond != null;

export const useBondsBondExists = () => {
  const response = useBondsBondTransformApi(bondsBondExist);
  return response;
};
